"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnerSearchResponse = void 0;
const common_1 = require("../../common");
const models_1 = require("../models");
class PartnerSearchResponse extends common_1.PaginatedResponse {
}
exports.PartnerSearchResponse = PartnerSearchResponse;
//# sourceMappingURL=partner-search.response.js.map